export default "__VITE_ASSET__61c62dbb__"